<script lang="ts">
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import Close from '~icons/mdi/close';
  import Premium from '~/icons/Premium.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { premiumModal } from '~/modals/PremiumModal.svelte';

  const welcomeModal = new ModalQueryState('welcome');

  const handleClose = () => {
    welcomeModal.pop();
  };

  const handleOpenPremium = () => {
    // TODO pop this?
    // pop();
    premiumModal.push();
  };
</script>

<Modal index={4} open={welcomeModal.open} onClose={handleClose}>
  {#snippet title()}
    You're logged in!
  {/snippet}
  {#snippet content()}
    <h2>Just one more step to get Premium</h2>
    <p>
      In order to get the most out of your Gram Jam account, you'll need to pay
      for Premium
    </p>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />
      CLOSE
    </ActionButton>
    <ActionButton onClick={handleOpenPremium}>
      <Premium />
      Get Premium
    </ActionButton>
  {/snippet}
</Modal>
